import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    standalone: false,
    selector: '[iCmsUtilViewContainer]'
})
export class ICmsUtilViewContainerDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
